module.exports = __webpack_public_path__ + "static/img/c7_commodity_list_1@2x.25486a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/c7_commodity_list_1@2x.png
// module id = 7Bd3
// module chunks = 1